import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=72fa9894&"
import script from "./modal.vue?vue&type=script&lang=ts&"
export * from "./modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72fa9894')) {
      api.createRecord('72fa9894', component.options)
    } else {
      api.reload('72fa9894', component.options)
    }
    module.hot.accept("./modal.vue?vue&type=template&id=72fa9894&", function () {
      api.rerender('72fa9894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/flags/modal.vue"
export default component.exports